define.alias("shared/components/shared/wizards/device-setup/step-two", "calendar/components/shared/wizards/device-setup/step-two");